import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { API_BASE_URL, GET_PO_RECEIVED_BY_ID, GET_STORE, INSERT_PURCHASE_ORDEDR } from '../../../Config';
import PropTypes from 'prop-types';
import Swal from "sweetalert2";
import SpinLoader from '../../../feature-module/loader/SpinLoader';
// import UploadFiles from '../../../feature-module/UploadFiles';

const ReceivePOStock = ({ POObj }) => {

    const [userDataSession, setUserDataSession] = useState(null);
    const [firstData, setFirstData] = useState(null);
    const [mainStoreId, setMainStoreId] = useState(0);
    const [mainStoreName, setMainStoreName] = useState('');
    const [editProducts, setEditProducts] = useState([]);
    const [formattedDate, setFormattedDate] = useState('');
    const [inputValues, setInputValues] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [errorMessages, setErrorMessages] = useState([]); 
    const [currentDate, setCurrentDate] = useState('');
    const [receivedDate, setReceivedDate] = useState('');
    const [loading, setLoading] = useState(false);
   const [isSubmitting, setIsSubmitting] = useState(false);
    // const [uploadData, setUploadData] = useState('');
    // console.log(POObj)

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    useEffect(() => {
        // Parse and format PODate
        if (POObj && POObj.PODate) {
            const poDate = new Date(POObj.PODate);
            const formatted = poDate.toISOString().split('T')[0];
            setFormattedDate(formatted);
        }

    }, [POObj]);

    useEffect(() => {
        if (userDataSession && POObj && POObj.PurchaseId) {
            setLoading(true);
            const url = `${API_BASE_URL}${GET_PO_RECEIVED_BY_ID}?PurchaseId=${POObj.PurchaseId}&UserId=${userDataSession.UserId}`;
            Axios.get(url)
                .then(response => {
                    if (response.data.Status) {
                        setLoading(false);
                        setEditProducts(response.data.ResultData);
                        // console.log(response.data.ResultData, 'getting recived products by poid');
                        setFirstData(response.data.ResultData[0]);
                        setSelectedRows(response.data.ResultData.map(() => true));
                        setInputValues(response.data.ResultData.map(item => ({
                            Quantity: item.Quantity,
                            UnitPrice: item.UnitPrice,
                            ReceivedQty: item.ReceivedQty || 0
                        })));
                    } else {
                        setLoading(false);
                        console.error('Error fetching data:', response.data.Message);
                    }
                })
                .catch(error => {
                    setLoading(false);
                    console.error('Error fetching data:', error);
                });
        }
    }, [userDataSession, POObj]);

    useEffect(() => {
        if (userDataSession && userDataSession.OrgId) {
            Axios.get(`${API_BASE_URL}${GET_STORE}?OrgId=${userDataSession.OrgId}`)
                .then(response => {
                    if (response.data.Status) {
                        const storesData = response.data.ResultData;
                        // setStoresData(storesData);
    
                        const mainStore = storesData.find(store => store.IsMainStore === true);
                        if (mainStore) {
                            setMainStoreId(mainStore.Id);
                            setMainStoreName(mainStore.Name);
                        } else {
                            console.log('No main store found');
                        }
                    } else {
                        console.error('Error fetching data:', response.data);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }
    }, [userDataSession]);

    const handleCheckboxChange = (index) => {
        const newSelectedRows = [...selectedRows];
        newSelectedRows[index] = !newSelectedRows[index];
        setSelectedRows(newSelectedRows);
    };

    const handleInputChange = (index, field, value) => {
        const newInputValues = [...inputValues];
        const newErrorMessages = [...errorMessages];

        if (field === 'ReceivedQty') {
            const maxAllowed = editProducts[index].Quantity - (editProducts[index].ReceivedQty || 0);
            if (Number(value) > maxAllowed) {
                newErrorMessages[index] = `Received quantity cannot exceed ${maxAllowed}`;
            } else {
                newErrorMessages[index] = '';
            }
        }

        newInputValues[index] = { ...newInputValues[index], [field]: value };
        setInputValues(newInputValues);
        setErrorMessages(newErrorMessages);
    };

    useEffect(() => {
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];
        setCurrentDate(formattedDate);
        setReceivedDate(formattedDate);
    }, []);

    // #region handle submit
    const handleSubmit = () => {
        const selectedProductDetails = editProducts
        .filter((item, index) => selectedRows[index])
        .map((item, index) => {
            const oldReceivedQty = item.ReceivedQty ? parseFloat(item.ReceivedQty) : 0;
            const newReceivedQty = inputValues[index].ReceivedQty ? parseFloat(inputValues[index].ReceivedQty) : 0;
            return {
                detailid: item.PurchaseDetailId,
                ProductId: item.ProductId,
                Quantity: inputValues[index].Quantity, 
                ReceivedQty: oldReceivedQty + newReceivedQty
            };
        });

        const requestBody = {
            orgid: userDataSession.OrgId,
            userid: userDataSession.UserId,
            MainStoreId: firstData.StoreId,
            SupplierId: firstData.SupplierId,
            PurchaseOrder: {
                Id: POObj.PurchaseId,
                StoreId: firstData.StoreId,
                SupplierId: firstData.SupplierId,
                POStatus: "RECEIVED",
                ReceiveDate: receivedDate ? receivedDate : currentDate
            },
            productdetails: selectedProductDetails
        };

        // console.log(requestBody, 'final valyes to sending api')
setIsSubmitting(true);
        Axios.post(`${API_BASE_URL}${INSERT_PURCHASE_ORDEDR}`, requestBody)
            .then(response => {
                // console.log('Response from API:', response.data);
                if (response.data[0].Success === 1) {
              
                    Swal.fire({
                        title: `Recevied Stock Updated Successfully.`,
                        icon: "success",
                    }).then((result) => {
                        if (result.isConfirmed || result.isDismissed) {
                           
                            window.location.reload();
                        }
                    });
                } else {
                    Swal.fire({
                        title: "Error",
                        text: "Failed to Submit.",
                        icon: "error",
                    });
                }
            })
            .catch(error => {
                console.error('Error submitting data:', error);
            })
           .finally(() => {
            setIsSubmitting(false);           
        });

    };   

console.log(mainStoreName,mainStoreId, "mainstoreName and id");
    return (
        <div>
            {isSubmitting && <SpinLoader/>}
            {/* Receive Purchase */}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightPORecSt"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: "53%", maxWidth: "53%" }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">Receive Stock <span className='text-primary'>(PO-{POObj?.AutoGentransactionNo})</span> </h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div> <hr/>
                {loading ? <div className='loader m-auto'></div> :
                    <div className="offcanvas-body">
                        <form >
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <div className="input-blocks">
                                        <label>Purchase Date</label>
                                        <div className="input-groupicon calender-input">
                                            <input 
                                                type='date'
                                                className='form-control'
                                                value={formattedDate}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <div className="input-blocks">
                                        <label>Store</label>
                                        <div className="input-groupicon calender-input">
                                            <input 
                                                type='text'
                                                className='form-control'
                                                // value={mainStoreName}
                                                value={firstData ? firstData?.StoreName : ""}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <div className="input-blocks">
                                        <label>Received Date<span className="fw-bold text-danger">*</span></label>
                                        <div className="input-groupicon calender-input">
                                            <input 
                                                type='date'
                                                className='form-control'
                                                value={receivedDate}
                                                onChange={(e) => setReceivedDate(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            <div className="row mb-2">
                                <div className="col-lg-12">
                                    <div className="modal-body-table">
                                        <div className="table-responsive">
                                            <table className="table  datanew">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Product</th>
                                                        <th>Ordered</th>
                                                        <th>Received</th>
                                                        <th>To Received</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {editProducts.length > 0 ? editProducts.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <label className="checkboxs">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedRows[index]}
                                                                        onChange={() => handleCheckboxChange(index)}
                                                                    />
                                                                    <span className="checkmarks"></span>
                                                                </label>
                                                            </td>
                                                            <td>{item.Productname}</td>
                                                            <td>{item.Quantity}</td>
                                                            <td>{item.ReceivedQty ? item.ReceivedQty : 0}</td>
                                                            <td>
                                                                <input
                                                                    className='form-control'
                                                                    type="number"
                                                                    // value={inputValues[index].ReceivedQty}
                                                                    onChange={(e) => handleInputChange(index, 'ReceivedQty', e.target.value)}
                                                                    style={{ width: '90px' }}
                                                                    onWheel={(e) => e.target.blur()}
                                                                />
                                                                {errorMessages[index] && <span className="error-message text-danger">{errorMessages[index]}</span>}
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan="8" className="text-center">No Data available</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>     
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            {/* <div className="mt-auto d-flex justify-content-end p-3">
                                <button
                                    type="button"
                                    className="btn btn-cancel me-2"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <button className='btn btn-primary me-2'>Submit</button>
                            </div> */}
                            <div className="d-flex justify-content-end sticky-bottom">
                                <button 
                                    type='button'
                                    onClick={handleSubmit} 
                                    className='btn btn-success me-3'
                                >
                                    Received<i className="fa-solid fa-download ms-1"></i>
                                </button>
                                {/* <button
                                    className='btn btn-primary'
                                    type='button'
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#offcanvasRightUploadFiles"
                                    aria-controls="offcanvasRightUploadFiles"
                                    onClick={() => handleStockUploadClick(POObj)}
                                >
                                    Upload <i className='fa-solid fa-cloud-arrow-up ms-2'></i>
                                </button> */}
                            </div>
                        </form>
                    </div>
                }
            </div>
            {/* <UploadFiles number={uploadData?.number} type={uploadData?.type} /> */}
        </div>
    )
}

ReceivePOStock.propTypes = {
    POObj: PropTypes.object.isRequired,
};

export default ReceivePOStock
